import { useContext } from "react";
import Image from "next/image";
import { Spinner, Text, Flex } from "@chakra-ui/react";

// Context
import { StakeContext } from "providers/StakeProvider";

// Utils
import { shortenAddress } from "utils/common";

const WalletInfo = () => {
  const { walletInfo, loading, balLoading, openAccountModal, providerInfo } =
    useContext(StakeContext);
  const { tokenBalance, tokenSymbol, address } = walletInfo;

  return (
    <Flex alignItems="center">
      {loading || balLoading ? (
        <Spinner size="md" color="brand.primary" />
      ) : (
        <>
          <Flex
            bg="brand.backgroundLight"
            padding={{ base: "0.5rem", lg: "1rem" }}
            boxShadow="0px 4px 12px rgba(53, 56, 140, 0.05)"
            borderRadius="8px"
            gap="4px"
            alignItems="center"
            cursor="pointer"
            lineHeight="20px"
            onClick={openAccountModal}
          >
            <Flex align="center" overflow="hidden" borderRadius="50%">
              <Image
                src={providerInfo.icon}
                width="20px"
                height="20px"
                alt="provider-icon"
              />
            </Flex>
            <Text
              as="span"
              fontSize={{ base: "14px", lg: "20px" }}
              fontFamily="semi-bold"
              ml={{ base: "4px", lg: "0.5rem" }}
            >
              {tokenBalance}
            </Text>
            <Text as="span" fontSize="12px" p="0 4px">
              {tokenSymbol}
            </Text>
            <Text
              bg="brand.background"
              as="span"
              fontSize="12px"
              p="0 16px"
              borderRadius="8px"
              color="brand.textColor"
              display={{ base: "none", lg: "inline" }}
            >
              {shortenAddress(address)}
            </Text>
          </Flex>
        </>
      )}
    </Flex>
  );
};

export default WalletInfo;
